import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "card-item__logo"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card-item__content" }
const _hoisted_5 = { class: "bold" }
const _hoisted_6 = {
  key: 0,
  class: "card-item__subtitle"
}
const _hoisted_7 = {
  key: 1,
  class: "payment-provider-limit-message"
}
const _hoisted_8 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card-item', { 'card-item--compact': _ctx.subtitle || _ctx.warningText, 'card-item--with-warning': !!_ctx.warningText }]),
    disabled: _ctx.inactive || undefined,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    (_ctx.logoSrc)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.logoSrc,
            alt: _ctx.logoAlt,
            style: _normalizeStyle({ maxWidth: _ctx.logoSize, maxHeight: _ctx.logoSize })
          }, null, 12, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true),
      (_ctx.warningText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.warningText), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.rightText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(['card-item__right', { bold: _ctx.rightTextBold }])
        }, _toDisplayString(_ctx.rightText), 3))
      : _createCommentVNode("", true),
    (_ctx.rightIcon)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          class: "card-item__chevron",
          src: typeof _ctx.rightIcon === 'string' ? _ctx.rightIcon : undefined,
          alt: _ctx.rightIconAlt
        }, null, 8, _hoisted_8))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}